import { takeEvery, fork, put, all, call, takeLatest } from "redux-saga/effects"
import Stripe from "stripe"

import {
  ADD_PLAN
} from "./actionTypes"

import { addPlanSuccessful, addPlanFailed, apiErrorPlanAct } from "./actions"
import { LystfacePlanAdd } from "../../../helpers/lystface_helper"

function* addPlanFn({ payload: { plan, history } }) {
  let planAddDet;
  try {
    console.log('hello')
    planAddDet = yield call(LystfacePlanAdd, plan)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = planAddDet
    if (responseCode == true) {
      yield put(addPlanSuccessful({ ...planAddDet, ...plan }))
    }
    else {
      yield put(addPlanFailed(planAddDet))
    }
  } catch (e) {
    console.log(e)
    yield put(addPlanFailed('There was an error activating plan,please try again later!'))
    yield put(apiErrorPlanAct())
  }
}


function* PlanSaga() {
  yield takeEvery(ADD_PLAN, addPlanFn)
}
export default PlanSaga
